export enum Theme {
    DARK = 'dark',
    LIGHT = 'light',
    GRAY = 'gray',
    GRAY_DARK = 'darkGray',
    BLACK = 'black',
    FORTNITE = 'fortnite'
}

export default Theme;
